import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFoundPages from './Components/NotFoundPages/NotFoundPages.js';

import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';

import Main from './Components/Main/Main';
import Developments from './Components/Developments/Developments';
import Services from './Components/Services/Services';
import MyWay from './Components/MyWay/MyWay';

import ParticlesBg from "particles-bg";

function App() {
  return (
    <div className='page'>
      <Header />
      <ParticlesBg color="#1E90FF" type="cobweb" bg={true}/>
      <div>
        <Routes>
          <Route path='/' element={<Main />} />
          {/* <Route path='/services' element={<Services />} /> */}
          <Route path='/myWay' element={<MyWay />} />
          <Route path='/developments' element={<Developments />} />
          <Route path='/Resources/Files/*' />
          <Route path='*' element={<NotFoundPages />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
